<div class="p-6 max-w-25rem">
  <div class="text-center mb-4">
    <i class="pi pi-exclamation-triangle text-6xl text-orange-500 mb-3"></i>
  </div>
  
  <div class="text-center mb-6">
    <h4 class="text-lg font-semibold text-gray-700 m-0 mb-4">{{ 'chat.dialog.delete-thread' | translate }}</h4>
    <p class="text-sm text-gray-600 m-0 mb-3 line-height-3">
      {{ 'chat.dialog.delete-confirm' | translate:{ threadId: data?.threadId } }}
    </p>
    <p class="text-xs text-red-600 font-italic m-0 line-height-3">
      {{ 'chat.dialog.delete-warning' | translate }}
    </p>
  </div>
  
  <div class="flex gap-3 justify-content-center">
    <p-button 
      [label]="'chat.dialog.cancel' | translate" 
      (onClick)="cancel()" 
      [outlined]="true" 
      severity="secondary">
    </p-button>
    <p-button 
      [label]="'chat.dialog.delete' | translate" 
      (onClick)="confirm()" 
      icon="pi pi-trash" 
      severity="danger">
    </p-button>
  </div>
</div>
